document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.featured-on');

  sections.forEach(function (section) {
    var track = section.querySelector('.featured-on__track');
    var navBtns = section.querySelector('.featured-on__nav-btns');
    var prevBtn = section.querySelector('.featured-on__nav--prev');
    var nextBtn = section.querySelector('.featured-on__nav--next');
    if (!track) return;

    var scrollByAmount = function () {
      var card = track.querySelector('.featured-on__card');
      if (!card) return 300;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || '20', 10) || 20;
      return card.getBoundingClientRect().width + gap;
    };

    var updateNavVisibility = function () {
      if (!navBtns) return;
      var hasOverflow = track.scrollWidth > track.clientWidth + 1;
      navBtns.style.display = hasOverflow ? '' : 'none';
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
      });
    }

    updateNavVisibility();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateNavVisibility, 150);
    });

    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 4000;

    if (autoplay) {
      var timer = null;

      var start = function () {
        if (track.scrollWidth <= track.clientWidth + 1) return;
        stop();
        timer = setInterval(function () {
          var maxScroll = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= maxScroll - 2) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
          }
        }, speed);
      };

      var stop = function () {
        if (timer) clearInterval(timer);
      };

      start();
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', start, { passive: true });
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var autoThumbs = document.querySelectorAll('.featured-on__auto-thumb[data-article-url]');

  autoThumbs.forEach(function (img) {
    var articleUrl = img.getAttribute('data-article-url');
    var fallback = img.getAttribute('data-fallback');
    if (!articleUrl) return;

    fetch('https://api.microlink.io/?url=' + encodeURIComponent(articleUrl) + '&palette=false')
      .then(function (res) { return res.json(); })
      .then(function (json) {
        var remoteImg = json && json.data && (
          (json.data.image && json.data.image.url) ||
          (json.data.screenshot && json.data.screenshot.url)
        );
        if (remoteImg) {
          img.src = remoteImg;
        } else if (fallback) {
          img.src = fallback;
        } else {
          img.closest('.featured-on__media').classList.add('featured-on__media--placeholder');
        }
      })
      .catch(function () {
        if (fallback) {
          img.src = fallback;
        } else {
          img.closest('.featured-on__media').classList.add('featured-on__media--placeholder');
        }
      });
  });
});